import styled from 'styled-components';

const DoctorBlockWrapper = styled.div`
   display: flex;
  .photo-wrapper {
    width: 40px;
    min-width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-right: 10px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .practitioner {
    width: calc(100% - 40px - 10px);
    p {
      overflow: hidden;
      margin: 0 0 0.3em;
      &.now-wrap {
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &.specialties {
        margin-bottom: 0;
        font-size: 14px;
        color: ${props => props.theme.color.label};
      }
    }
  }
`;

export default {
  DoctorBlockWrapper
};